import React from 'react';

let article0 = {
    "tag": "home-article",
    "linkTitle": [<a href="/">Welcome to our site!</a>],
    "title": "Welcome to our site!",
    "shortContent": "",
    "content": ['We always post the latest on what we\'re doing on our ', <a title="News" href="/news">News page</a>, '.  If you need to contact us, take a look at our ', <a title="Contact" href="/contact">Contact page</a>, '.  You can always see our ', <a title="Privacy" href="/privacy">Privacy Policy here</a>, '.'],
    "date": "",
    "groups": [],
    "tags": []
};

let article1 = {
    "tag": "play-fling",
    "linkTitle": [<a href="/play-fling">How to Play Fling It!</a>],
    "title": "How to Play Fling It!",
    "shortContent": "We’ve had some people ask, “How do you move the ball?” “Do you touch and fling it?” Fling It! uses your device’s built in motion sensors. Thes...",
    "content": [<p>We've had some people ask, "How do you move the ball?" "Do you touch and fling it?"</p>, <p>Fling It! uses your device's built in motion sensors. These sensors measure when you move the device from side to side, forward and back, or up and down.</p>, <p>Your ball needs to be stopped before you can fling it. Either wait until it stops or try to catch it by touching it. It will turn green when it's stopped.</p>, <p>All you have to do is wait till the ball turns green (green means go), and shake your device side to side or forward and back.</p>, <p>You just "Fling It!"</p>, <p>Don't forget, you can get Fling It! on Google Play and the Amazon AppStore.</p>, <p><a href="https://play.google.com/store/apps/details?id=com.oldawg.games.flingit"><br /><img src="https://developer.android.com/images/brand/en_generic_rgb_wo_45.png" alt="Get it on Google Play" /><br /></a></p>, <p><a href="http://www.amazon.com/gp/product/B00RWIEHU2/ref=mas_pm_fling_it"><br /><img src="http://oldawg.com/wp-content/uploads/2015/01/amazon-apps-store-us-black.png" alt="Available at Amazon" /><br /></a></p>],
    "date": "2015-01-17",
    "groups": [],
    "tags": []
};

let article2 = {
    "tag": "fling-amazon",
    "linkTitle": [<a href="/fling-amazon">Fling It! on Amazon</a>],
    "title": "Fling It! on Amazon",
    "shortContent": "Fling It! is now available for download from the Amazon Appstore. Look for it here:...",
    "content": [<p>Fling It! is now available for download from the Amazon Appstore.</p>, <p>Look for it here:</p>, <a href="http://www.amazon.com/gp/product/B00RWIEHU2/ref=mas_pm_fling_it"><br /><img src="http://oldawg.com/wp-content/uploads/2015/01/amazon-apps-store-us-black.png" alt="Available at Amazon" /><br /></a>],
    "date": "2015-01-11",
    "groups": [],
    "tags": []
};

let article3 = {
    "tag": "fling-coming-amazon-appstore",
    "linkTitle": [<a href="/fling-coming-amazon-appstore">Fling It! – coming to the Amazon Appstore?</a>],
    "title": "Fling It! – coming to the Amazon Appstore?",
    "shortContent": "Keep an eye out here for news about Fling It! and the Amazon Appstore....",
    "content": ['Keep an eye out her for news about Fling It! and the Amazon Appstore.'],
    "date": "2015-01-06",
    "groups": [],
    "tags": []
};

let article4 = {
    "tag": "fling-google-play",
    "linkTitle": [<a href="/fling-google-play">Fling It! on Google Play</a>],
    "title": "Fling It! on Google Play",
    "shortContent": "Version 1.0.0.0 of Fling It! is now available for download from the Google Play Store. Look for it here:...",
    "content": [<p>Version 1.0.0.0 of Fling It! is now available for download from the Google Play Store.</p>, <p>Look for it here:</p>,<a href="https://play.google.com/store/apps/details?id=com.oldawg.games.flingit"><br /><img src="https://developer.android.com/images/brand/en_generic_rgb_wo_45.png" alt="Get it on Google Play" /><br /></a>],
    "date": "2015-01-04",
    "groups": [],
    "tags": []
};

let article5 = {
    "tag": "upcoming-release-fling-it",
    "linkTitle": [<a href="/upcoming-release-fling-it">Upcoming Release – Fling It</a>],
    "title": "Upcoming Release – Fling It!",
    "shortContent": "Keep an eye here for news of our upcoming Android release, “Fling It!”...",
    "content": ['Keep an eye here for news of our upcoming Android release, “Fling It!”'],
    "date": "2015-01-01",
    "groups": [],
    "tags": []
};

var articles = [article0, article1, article2, article3, article4, article5];

class NewsApi {
  static getAllNews() {
      return Object.assign([], articles);
  }

  static getArticle(tag) {
    const newsArticle = articles.find(article => {
        return article.tag === tag
    });

    return Object.assign({}, newsArticle);
  }
}

export default NewsApi;